<template lang="pug">
.dialog-container(id="DialogDuplicateRecursive-container")
  .container(v-if='this.$store.state.Medium.media_selected_left.length > 0')
    h4
      font-awesome-icon.linker-icon(v-if='!saving', icon="copy")
      | &nbsp; {{$t('Clone recursive')}}:&nbsp;{{ !multiplePlaylists ? this.$store.state.Medium.media_selected_left[0].name : this.$store.state.Medium.media_selected_left.length + $t(' playlists')}}
    hr.header
  .container
    section.center(v-if='multiplePlaylists')
      p.warning {{$t('Please, provide rename rules for copies of container media that will be created.')}}
      el-input.el-input(
        id="DialogDuplicateRecursive-searchString",
        ref='searchString',
        v-model='searchString',
        type="text",
        style="width: 200px;",
        size='mini',
        :placeholder='$t("search for")',
        @keyup.enter.native="duplicatePlaylistRecursive()"
      )
      span &nbsp;
      font-awesome-icon.linker-icon(icon="arrow-right")
      span &nbsp;
      el-input.el-input(
        id="DialogDuplicateRecursive-replaceString",
        ref='replaceString',
        v-model='replaceString',
        type="text",
        style="width: 200px",
        size='mini',
        :placeholder='$t("replace with")',
        @keyup.enter.native="duplicatePlaylistRecursive()"
      )
    section(v-if='!multiplePlaylists')
      p.warning {{$t('Please, provide suffix for copies of container media that will be created.')}}
      el-input.el-input(
        id="DialogDuplicateRecursive-suffixInput",
        ref='suffix',
        v-model='suffix',
        type="text",
        style="width: 60%;",
        size='mini',
        @keyup.enter.native="duplicatePlaylistRecursive()"
      )
      hr.header
    p {{$t('Container medium will be duplicated, along with all it\'s container media, and all copies placed along with original in library. Non-container media will be assigned to newly created playlist, but will not be duplicated. Time restrictions and display properties will be preserved.')}}
  .container.float-right
    el-button(id="DialogDuplicateRecursive-duplicateButton" type="success", @click="duplicatePlaylistRecursive()", size='mini', :disabled='saving')
        | &nbsp; {{ saving ? $t("cloning...") : $t("Clone")}} &nbsp;
        font-awesome-icon.linker-icon(v-if='!saving', icon="copy")
</template>

<script>

export default {
  props: ['multiplePlaylists'],
  components: {
  },
  created () {
    console.log('this.multiplePlaylists', this.multiplePlaylists)
    this.media = !this.multiplePlaylists ? [this.$store.state.Medium.media_selected_left[0]] : this.$store.state.Medium.media_selected_left
    if (!this.multiplePlaylists) {
      this.$nextTick(() => {
        this.$refs.suffix.focus()
      })
    }
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: '',
      media: [],
      suffix: '_recursive_copy',
      searchString: '',
      replaceString: '',
      replaceNameExample: ''
    }
  },
  methods: {
    async duplicatePlaylistRecursive () {
      this.$emit('linkerJobStarted')
      this.saving = true
      if (this.media.length === 1) {
        await this.$store.dispatch('Medium/duplicatePlaylistRecursive', { suffix: this.suffix, playlist: this.media[0] })
      } else {
        await this.$store.dispatch('Medium/duplicatePlaylistsRecursive', {
          searchString: this.searchString, replaceString: this.replaceString, playlist: this.media
        })
      }
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
      this.$emit('linkerJobDone', 'duplicateRecursive')
      this.saving = false
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
.confirm {
  height: 100px;
  width: 100px;
  font-size: 12px;
  margin-top: auto auto;
  text-transform: uppercase;
  &.spinner {
    .spinner-icon {
      font-size: 40px;
      margin-top: -10px;
    }
    .spinner-text {
      font-size: 10px;
      margin-top: 9px;
    }
  }
}
.centered {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogDuplicateRecursive.vue